<template>
  <v-hover>
    <v-btn
      slot-scope="{ hover }"
      flat
      icon
      :color="`${hover ? finalEventHoverColor : finalEventColor}`"
      @click="$emit('click')"
    >
      <v-badge small :color="finalBadgeColor" flat overlap>
        <v-icon v-if="!hover" flat slot="badge">{{ finalBadgeIcon }}</v-icon>
        <v-icon
          :color="`${hover ? finalEventHoverColor : finalEventColor}`"
          v-html="`${hover ? finalHoverIcon : finalEventIcon}`"
        ></v-icon>
      </v-badge>
    </v-btn>
  </v-hover>
</template>

<script>
export default {
  props: [
    'status',
    'color',
    'badgeColor',
    'eventColor',
    'eventHoverColor',
    'badgeIcon',
    'eventIcon',
    'eventHoverIcon',
  ],
  data() {
    return {};
  },
  computed: {
    finalBadgeIcon() {
      if (this.badgeIcon) {
        return this.badgeIcon;
      } else {
        let icon = '';
        switch (this.status) {
          case 'in_progress':
            icon = 'mdi-clock-outline';
            break;
          case 'confirmed':
            icon = 'mdi-check';
            break;
          case 'error':
            icon = 'mdi-alert-circle-outline';
            break;
          default:
            icon = 'mdi-clock-outline';
            break;
        }
        return icon;
      }
    },
    finalEventIcon() {
      return this.eventIcon ? this.eventIcon : 'mdi-calendar-blank';
    },
    finalHoverIcon() {
      return this.eventHoverIcon ? this.eventHoverIcon : 'mdi-calendar-blank';
    },
    finalColor() {
      return this.color ? this.color : 'grey lighten-1';
    },
    finalBadgeColor() {
      return this.badgeColor ? this.badgeColor : this.finalColor;
    },
    finalEventColor() {
      return this.eventColor ? this.eventColor : this.finalColor;
    },
    finalEventHoverColor() {
      return this.eventHoverColor ? this.eventHoverColor : this.finalEventColor;
    },
  },
};
</script>

<style></style>
